import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonDirective } from '@com-delta-omnichannel/aura';
import { Review } from './models/review.interfaces';

@Component({
  selector: 'idp-review',
  standalone: true,
  imports: [ButtonDirective, CommonModule],
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})
export class ReviewComponent {
  @Input() content: Review = {} as Review;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() confirm: EventEmitter<boolean> = new EventEmitter<boolean>();

  onAction(id: string) {
    id === 'cancel' ? this.closeModal.emit() : this.confirm.emit();
  }
}
